var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SportsCarouselItem } from "../SportsCarouselItem";
import { DateCarouselItem } from "../DateCarouselItem";
var typeMap = {
    sports: function (props) { return (React.createElement(SportsCarouselItem, __assign({}, props))); },
    favorites: function (props) { return (React.createElement(SportsCarouselItem, __assign({}, props))); },
    liveStream: function (props) { return (React.createElement(SportsCarouselItem, __assign({}, props))); },
    allSports: function (props) { return (React.createElement(SportsCarouselItem, __assign({}, props))); },
    dates: function (props) { return (React.createElement(DateCarouselItem, __assign({}, props))); }
};
export var CarouselItem = function (props) {
    return typeMap[props.item.type](props);
};
//# sourceMappingURL=CarouselItem.js.map